(function() {
  'use strict';
  angular.module('ringbaPortal').controller('DashboardLayoutController', DashboardLayoutController);

  function DashboardLayoutController(
    $rootScope,
    $scope,
    $timeout,
    accountsService,
    sidebarService,
    cacheService,
    moment,
    utilities,
    VuexStore,
    envFeatures
  ) {
    'ngInject';

    const vm = this;
    let showThemeEditorHandler;
    const render = utilities.safeApply.bind($scope);

    vm.$onInit = onInit;
    vm.$onDestroy = onDestroy;
    vm.hideThemeEditor = hideThemeEditor;
    vm.sidebarService = sidebarService;
    vm.isAdmin = accountsService.isAdmin;
    vm.hasMFA = true; // Default to true to avoid content flash, will be updated based on the user's MFA status
    vm.enforceMfa = false;
    vm.accountMFAEnforceDate = null;
    vm.isMfaDisabled = __BUILD_CONFIG__.isDevBuild && envFeatures.isMfaDisabled;

    function onInit() {
      utilities.ngVueEventBus.$on(utilities.ngVueEvents.EVENT_SHOW_TOASTER, render);
      showThemeEditorHandler = $rootScope.$on('showThemeEditor', _showThemeEditor);
      vm.uploadKycNotificationSettings = { hideUploadKycNotification: true };

      _checkToShowRequireMFABanner(); // TODO: remove this when after the grace period
    }

    function onDestroy() {
      if (showThemeEditorHandler) {
        showThemeEditorHandler();
      }
    }

    function hideThemeEditor() {
      vm.isThemeEditorOpen = false;
    }

    // TODO: remove this when after the grace period
    function _checkToShowRequireMFABanner() {
      const authData = cacheService.get('authService.authorizationData');
      const mfaEnforceDate = moment.utc(authData?.mfaEnforceDate);
      vm.enforceMfa = authData?.enforceMfa || false;

      // Only add the listener and fetch the enabled MFA methods if the user is within the grace period
      if (!vm.enforceMfa) {
        // Add a listener for the MFA success event, this will be emitted when the user successfully enables MFA
        const mfaSuccessHandler = $rootScope.$on('mfaEnabledSuccess', function () {
          vm.hasMFA = true; // Update the controller state
          $scope.$apply(); // Trigger AngularJS digest cycle to update the view
          mfaSuccessHandler(); // Deregister the listener, only needed once
        });

        // Get the enabled MFA method onInit and set the hasMFA flag
        VuexStore.dispatch('twoFactorAuth/getTwoFactorMethods').then(() => {
          vm.hasMFA = VuexStore.getters['twoFactorAuth/enabledMFAMethods'].length > 0;
        });

        // Translate MFA enforce date to to the account's timezone
        const timezone = VuexStore.getters['accountTranslatedTimeZoneId'];
        vm.accountMFAEnforceDate = moment(mfaEnforceDate).tz(timezone).format('MMMM DD, YYYY');
      }

    }

    function _showThemeEditor() {
      vm.isThemeEditorOpen = true;
    }

    $scope.$on('$viewContentLoaded', function() {
      $timeout(function() {
        VuexStore.dispatch('exportFiles/checkPendingJobs');
      }, 0);
    });
  }
})();
